// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3iwpz","header":"ReportDetails_header__Rvqcw","title":"ReportDetails_title__JRx-v","left":"ReportDetails_left__3c6bp"};